import React, { useEffect, useState } from "react";
import './DonutChart.css'
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
var _ = require('lodash');

function CustomDonutChart(props) {
  const { t } = useTranslation();
  const [series, setseries] = useState(props.series);
  const fillColors = props.fillColors;
  const [options, setOptions] = useState({});
  const [width, setwidth] = useState(props.width);
  const [normalizedWidth, setnormalizedWidth] = useState(props.width);

  const defaultTooltipFormatter = (value, opts) => {
    return value + "%";
  }

  const prepareLabels = (data) => {
    const {showPercentage,title, subtitle} = data;
    let label = {}
    if(showPercentage) {
      label = {
        show: true,
        name: { show: true, fontSize: "90%", offsetY: 2 },
        value: {
          show: true,
          fontSize: "90%",
          offsetY: -2,
          formatter: (v) => v + "%",
        },
        total: {
          show: true,
          fontSize: "90%",
          formatter: function (w) {
            return (
              w.globals.seriesTotals.reduce((a, b) => {
                return a + b;
              }, 0) + "%"
            );
          },
        },
      }
    } else {
      if(title || subtitle){
        label = {
          show: true,
          name: title
            ? {
                show: true,
                offsetY: 2,
                fontSize: "90%",
                formatter: () => title,
              }
            : { show: false },
          value:
            subtitle !== undefined || subtitle !== null
              ? {
                  show: true,
                  offsetY: -2,
                  fontSize: "80%",
                  formatter: (w) => subtitle,
                }
              : { show: false },
          total: {
            show: true,
            label: title,
            fontSize: "90%",
            formatter: function (w) {
              return subtitle !== undefined || subtitle !== null
                ? subtitle
                : "";
            },
          },
        }
      }
      else {
        label = {show:false};
      }
    }
    return label;
  }

  const prepareChart = (props) => {
    const {
      labels,
      subtitle,
      legendPosition,
      title,
      tooltipDisabled,
      showLegend,
      showPercentage,
      toolTipValueDisable,
      customTooltipFormatter
    } = props;

    const validData = _.filter(props.series, (value)=>{
      return _.isNumber(value) && !_.isNaN(value);
    });
    const len = parseInt(validData.length/3,10);
    setnormalizedWidth( parseInt(width) + len*15);
    
    const lbls = prepareLabels(props);

    let opts = {
      subtitle:{
        text:subtitle,
        align:'center',
        floating:true,
        style:{
          fontSize:'0'
        }
      },
      tooltip: {
        enabled: tooltipDisabled ? false : true
      },
      dataLabels: {
        enabled: false,
      },
      labels: labels,
      legend: {
        show: showLegend === false ? false : true,
        position: legendPosition,
        onItemClick: {
          toggleDataSeries: true,
        },
      },
      plotOptions: {
        pie:{
          donut: {
            labels:lbls
          }
        }
      },
      chart: {
        toolbar: {
          show: true,
          tools: {
            download: false,
            pan: true,
          },
        },
      },
    };

    
  
    if (fillColors) {
      opts.colors = fillColors;
      opts.fill = {colors:fillColors};
    }
    if ( customTooltipFormatter instanceof Function) {
      opts.tooltip.custom = customTooltipFormatter;
    } else {
      opts.tooltip.y  = {formatter : defaultTooltipFormatter};
    }
  
    if(validData.length === 1 && validData[0] === 0) {
      opts.fill = {colors:['#F3F5F9']};
      opts.states = {hover: {
        filter: {
           type: 'none'
         }
       }}
    }

    setOptions(opts);
    setseries(validData);
  }

  useEffect(() => {
     prepareChart(props)
  }, []);
  
  useEffect(() => {
     prepareChart(props);
  }, [props.series]);
  
  return  !_.isEmpty(series) ? 
        <Chart options={options} series={(series.length === 1 && series[0] === 0)?[100]:series} type="donut" width={width?normalizedWidth:150} /> 
        : <div style={{"height" : '250px'}} className="cv-donut-chart fs12" >{t("LT_no_data_available")}</div>;
  
}

export default CustomDonutChart;
